// ============================================================================
// FNE-BRIDGE Frontend - Guard d'authentification
// ============================================================================

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores';
import { PUBLIC_ROUTES, PROTECTED_ROUTES } from '../../config/routes';

// --- Route protégée : redirige vers login si non authentifié ---
export const ProtectedRoute: React.FC<{ allowedRoles?: string[] }> = ({ allowedRoles }) => {
  const { isAuthenticated, user, mustChangePassword, licenseExpired } = useAuthStore();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={PUBLIC_ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  // Licence expirée — l'admin principal ne peut accéder qu'à la page Paramétrage
  if (licenseExpired && location.pathname !== PROTECTED_ROUTES.SETTINGS) {
    return <Navigate to={PROTECTED_ROUTES.SETTINGS} replace />;
  }

  // Forcer le changement de mot de passe
  if (mustChangePassword && location.pathname !== PROTECTED_ROUTES.CHANGE_PASSWORD) {
    return <Navigate to={PROTECTED_ROUTES.CHANGE_PASSWORD} replace />;
  }

  // Vérification des rôles
  if (allowedRoles && user?.role && !allowedRoles.includes(user.role)) {
    return <Navigate to={PROTECTED_ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
};

// --- Route publique : redirige vers dashboard si déjà authentifié ---
export const PublicRoute: React.FC = () => {
  const { isAuthenticated } = useAuthStore();

  if (isAuthenticated) {
    return <Navigate to={PROTECTED_ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
};
